
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Terminalmumbai() {



    const cardData =
    {
        keyword: ' Terminal 1,2,3 Mumbai Airport to Pune Cab ',
        heading: 'Skyline Cabs: Terminal 1,2,3 Mumbai Airport to Pune Cab ',
        headingDescription: 'Skyline Cabs offers efficient and comfortable Mumbai Airport (Terminal 1, 2, 3) to Pune Cab service for a seamless airport-to-city transfer. Whether you are arriving for business, leisure, or a family visit, our professional drivers and clean, well-maintained vehicles ensure a smooth journey from any terminal. With timely pickups, transparent pricing, and 24/7 customer support, Skyline Cabs is your reliable choice for stress-free travel from Mumbai Airport to Pune. Book your cab today and enjoy a safe, comfortable ride with complete peace of mind.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
  {
    "name": "Mumbai Airport Terminal 1 to Pune Cab Fare",
    "description": "Skyline Cabs offers reliable and affordable taxi services from Mumbai Airport Terminal 1 to Pune. Our fare structure is clear, with no hidden charges, ensuring a smooth and budget-friendly ride. Whether you're traveling for business or leisure, enjoy a comfortable journey in one of our well-maintained vehicles."
  },
  {
    "name": "Mumbai Airport Terminal 2 to Pune Cab",
    "description": "Travel from Mumbai Airport Terminal 2 to Pune with Skyline Cabs. Our taxi services provide comfortable rides, punctual service, and competitive fares. We offer a range of vehicle options to meet your needs, ensuring a hassle-free journey with experienced drivers who are familiar with the best routes."
  },
  {
    "name": "Mumbai Airport Terminal 3 to Pune Cab",
    "description": "Skyline Cabs offers convenient and reliable taxi services from Mumbai Airport Terminal 3 to Pune. Whether you're arriving on a late-night flight or during peak hours, our 24x7 service ensures you have a comfortable and safe ride with clear and transparent pricing."
  },
  {
    "name": "Mumbai Domestic Airport Terminal 1 to Pune Cab",
    "description": "For a seamless journey from Mumbai Domestic Airport Terminal 1 to Pune, Skyline Cabs provides affordable taxi services. Our fleet includes a variety of vehicles such as sedans, SUVs, and luxury cars, ensuring comfort and reliability for your ride."
  },
  {
    "name": "Mumbai Domestic Airport Cab",
    "description": "Skyline Cabs offers reliable and timely taxi services from Mumbai's Domestic Airport to various destinations. Whether you need a ride to the city or outstation destinations like Pune, we provide transparent fares, comfort, and punctuality with well-maintained vehicles."
  },
  {
    "name": "Mumbai International Airport Taxi",
    "description": "Skyline Cabs provides 24x7 taxi services from Mumbai International Airport to your desired destination. Our service guarantees comfort, safety, and punctuality. We offer affordable pricing with no hidden charges for both short and long-distance trips."
  },
  {
    "name": "24x7 Mumbai Airport Cab Booking",
    "description": "Skyline Cabs offers round-the-clock taxi booking services for passengers traveling to and from Mumbai Airport. Book your cab anytime, day or night, through our online system. Our fleet includes a variety of vehicles to cater to your specific needs, with clear and competitive pricing."
  },
  {
    "name": "Mumbai Airport Outstation Taxi",
    "description": "Skyline Cabs offers affordable outstation taxi services from Mumbai Airport to various destinations like Pune, Lonavala, and more. Whether it's a one-way trip or a round trip, we provide comfort, reliability, and excellent customer service for your outstation journey."
  },
  {
    "name": "Mumbai Airport Innova Cabs",
    "description": "For a luxurious and spacious ride, choose Skyline Cabs' Innova Crysta for your journey from Mumbai Airport. Ideal for families or groups, the Innova Crysta offers ample space and comfort. Our experienced drivers ensure your safety and timely arrival at your destination."
  },
  {
    "name": "Mumbai Airport Ertiga Taxi",
    "description": "Skyline Cabs offers the Ertiga as a comfortable and affordable option for your journey from Mumbai Airport. Perfect for small families or group travel, the Ertiga is spacious and ensures a smooth ride. Book your Ertiga taxi for a reliable and comfortable experience."
  },
  {
    "name": "Mumbai Airport Sedan Cab Service",
    "description": "Travel in comfort and style with our sedan cabs from Mumbai Airport. Whether you're heading to the city or outstation destinations, our well-maintained sedans provide a smooth and comfortable ride. With clear and competitive pricing, Skyline Cabs ensures a reliable and stress-free travel experience."
  },
  {
    "name": "Mumbai Airport Terminal 2 Taxi Service",
    "description": "Skyline Cabs offers dependable taxi services from Mumbai Airport Terminal 2 to your desired destination. Whether you're traveling to Pune, the city, or nearby destinations, our fleet of well-maintained vehicles and experienced drivers ensures a comfortable journey with transparent pricing."
  },
  {
    "name": "Transport Facility at Mumbai Airport",
    "description": "Skyline Cabs offers top-notch transport facilities at Mumbai Airport, making your journey seamless and stress-free. From taxis to outstation cabs, we ensure reliable service with a variety of vehicle options. Book your ride directly from the airport or through our online booking system."
  },
  {
    "name": "Book Airport Services Online",
    "description": "Book your Mumbai Airport taxi services online with Skyline Cabs. Our user-friendly booking system allows you to easily select the vehicle type, travel dates, and ensure a hassle-free ride to your destination. Enjoy the convenience of booking airport services from the comfort of your home."
  },
  {
    "name": "Book Airport Services Online India",
    "description": "Skyline Cabs offers online airport booking services across India. Whether you're traveling from Mumbai, Delhi, or any other major city, you can book your airport taxi services easily. Choose from a range of vehicles, and enjoy transparent pricing and excellent service."
  },
  {
    "name": "Book Mumbai Airport Services Online",
    "description": "Booking a taxi from Mumbai Airport has never been easier with Skyline Cabs' online booking service. Our platform allows you to choose your vehicle, make payments securely, and ensure a stress-free journey from the airport to your destination."
  },
  {
    "name": "Book Mumbai Airport Services Online Terminal 1",
    "description": "Skyline Cabs offers a convenient online booking system for passengers arriving at Mumbai Airport Terminal 1. Book your ride in advance and enjoy a smooth transition from the terminal to your destination with our reliable and comfortable taxi services."
  }
],
"tableData": [
  ["Mumbai Airport Terminal 1 to Pune Cab Fare", "Mumbai Airport Terminal 2 to Pune Cab"],
  ["Mumbai Airport Terminal 3 to Pune Cab", "Mumbai Domestic Airport Terminal 1 to Pune Cab"],
  ["Mumbai Domestic Airport Cab", "Mumbai International Airport Taxi"],
  ["24x7 Mumbai Airport Cab Booking", "Mumbai Airport Outstation Taxi"],
  ["Mumbai Airport Innova Cabs", "Mumbai Airport Ertiga Taxi"],
  ["Mumbai Airport Sedan Cab Service", "Mumbai Airport Terminal 2 Taxi Service"],
  ["Transport Facility at Mumbai Airport", "Book Airport Services Online"],
  ["Book Airport Services Online India", "Book Mumbai Airport Services Online"],
  ["Book Mumbai Airport Services Online Terminal 1", ""]
],



whychoose: [
    {
        "WhyChooseheading": "Reliable Mumbai Airport to Pune Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers reliable and punctual cab services from Terminal 1, 2, and 3 of Mumbai Airport to Pune. Whether you’ve just arrived from a flight or need a timely departure, we ensure a smooth, hassle-free journey every time."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Our fleet includes well-maintained, air-conditioned sedans, SUVs, and luxury cars, designed for comfort and relaxation. Whether you're traveling solo, with family, or in a group, we have a vehicle to suit your needs for the Mumbai Airport to Pune journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced drivers are well-versed with the best routes from Mumbai Airport to Pune. They ensure timely pickups, follow all safety guidelines, and prioritize your comfort throughout the journey, making your trip enjoyable and stress-free."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Skyline Cabs provides transparent pricing with no hidden charges. You’ll always know the cost upfront for your trip from Mumbai Airport to Pune, offering great value for high-quality service."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "We operate 24/7, so you can book a ride from Mumbai Airport to Pune at any time. Whether it's an early morning flight or a late-night arrival, we're ready to serve you at any hour of the day or night."
    },
    {
        "WhyChooseheading": "Easy and Quick Online Booking",
        "WhyChoosedescription": "Booking your ride from Mumbai Airport to Pune is easy with Skyline Cabs. Use our website or mobile app to book your cab in just a few clicks, and enjoy instant booking confirmation along with real-time tracking of your ride."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Vehicles",
        "WhyChoosedescription": "The health and safety of our passengers are our top priority. All our vehicles are thoroughly sanitized after every ride, and our drivers follow strict hygiene protocols to ensure a safe and clean environment for your journey."
    },
    {
        "WhyChooseheading": "Variety of Vehicles to Suit Your Needs",
        "WhyChoosedescription": "Skyline Cabs offers a wide range of vehicles to cater to all your travel needs. Whether you're traveling alone, with family, or in a group, we have the ideal vehicle for your Mumbai Airport to Pune trip, including sedans, SUVs, and more spacious options."
    }
]




















    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Terminal 1, 2, 3 Mumbai Airport to Pune with Skyline Cabs?',
            answer:
                'Booking a cab from Terminal 1, 2, 3 Mumbai Airport to Pune is easy and convenient. You can book through our website, mobile app, or by calling our customer support team. Just provide your terminal, pickup details, and destination, then select your preferred vehicle and confirm the booking.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for the Mumbai Airport to Pune trip?',
            answer:
                'We offer a wide range of vehicles including Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars. Choose the vehicle type that best suits your passenger count and comfort needs.',
        },
        {
            id: 3,
            question: 'How long does it take to travel from Mumbai Airport Terminals 1, 2, or 3 to Pune?',
            answer:
                'The travel time from any Mumbai Airport terminal (T1, T2, or T3) to Pune typically ranges from 3.5 to 5 hours, depending on traffic and weather conditions. Our experienced drivers take the most efficient routes for a timely arrival.',
        },
        {
            id: 4,
            question: 'Are the cab fares from Mumbai Airport to Pune fixed?',
            answer:
                'Yes, we offer fixed and transparent pricing for all airport-to-Pune routes. Our rates include tolls, taxes, and driver charges, so you know the full fare before confirming the ride.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip from Mumbai Airport to Pune?',
            answer:
                'Absolutely! You can schedule a round-trip while booking your cab. Just mention your return trip details, and we’ll ensure a comfortable ride both ways.',
        },
        {
            id: 6,
            question: 'Can I make changes to my Mumbai Airport to Pune cab booking?',
            answer:
                'Yes, you can modify or cancel your booking at any time via our website, app, or by calling our support team. We provide flexible rescheduling and cancellation policies.',
        },
        {
            id: 7,
            question: 'Are the vehicles for the Mumbai Airport to Pune journey clean and reliable?',
            answer:
                'Yes, all Skyline Cabs vehicles are regularly serviced and cleaned to provide a safe and comfortable travel experience. Cleanliness and reliability are top priorities for every ride.',
        },
        {
            id: 8,
            question: 'What payment options do I have for my Mumbai Airport to Pune cab?',
            answer:
                'You can pay online via credit/debit cards, UPI, or net banking. Cash payment at the end of the journey is also available if preferred.',
        },
        {
            id: 9,
            question: 'Is Skyline Cabs available for business travel from Mumbai Airport to Pune?',
            answer:
                'Yes, we offer professional corporate cab services from all Mumbai Airport terminals to Pune. Reach out to us for tailored packages for business meetings, events, or group travel.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Mumbai Airport to Pune journey?',
            answer:
                'Skyline Cabs offers professional drivers, well-maintained vehicles, fixed pricing, and dependable service. Whether you’re flying in or flying out, we ensure a stress-free journey from Mumbai Airport to Pune.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "I booked Skyline Cabs from Mumbai Airport Terminal 2 to Pune and had a great ride. The driver met me at arrivals on time, and the vehicle was spotless. Very professional service!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "Used Skyline Cabs from Terminal 1 to Pune. Everything was smooth—driver was helpful and the cab was comfortable. Just a minor delay at pickup, but the rest of the trip was excellent."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Terminal 1, 2, 3 Mumbai Airport to Pune Cab",
  "image": "https://skylinecabs.com/assets/images/mumbai-airport-terminals-to-pune-cab.jpg",
  "description": "Book cab from Terminal 1, 2, or 3 at Mumbai Airport to Pune with Skyline Cabs. Enjoy reliable, AC sedan/SUV rides with professional drivers — available 24/7 for one-way and round-trip journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7673"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-airport-terminals-to-pune-cab"
  }
};



      


    return (
        <div>
<Helmet>
  <title>Mumbai Airport Terminal 1, 2, 3 to Pune Cab | 24x7 Pickup | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book cab from Terminal 1, 2, or 3 at Mumbai Airport to Pune with Skyline Cabs. Enjoy reliable, AC sedan/SUV rides with professional drivers — available 24/7 for one-way and round-trip journeys." 
  />
  <meta 
    name="keywords" 
    content="Terminal 1 to Pune Cab, Terminal 2 to Pune Cab, Terminal 3 to Pune Cab, Mumbai Airport to Pune Cab, Airport Cab Mumbai to Pune, One-Way Taxi Terminal 1 2 3 to Pune, AC Cab Mumbai Airport to Pune, SUV Cab to Pune from Mumbai Airport, Skyline Cabs Mumbai Airport Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/51.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Terminalmumbai;